import { MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export default styled(MenuItem)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(12),
  fontWeight: theme.typography.fontWeightMedium,
}));
